module.exports = __webpack_public_path__ + "static/media/rubik-v14-latin-regular.b0ff84c3.woff";